import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import Table, { buttonsStyle } from '../../../components/tables/table'
import { getS11MapsAdmin } from '../../../../api/s11Map'
import { Button, Tooltip } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import { alertError } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'

function truncateUrl(url) {
  if (!url) return '—'
  if (url.length <= 60) return url
  return `${url.slice(0, 57)}...`
}

function getData(maps) {
  return maps.map((m) => ({
    id: m.key,
    key: m.key,
    fullName: m.fullName,
    url: truncateUrl(m.url),
  }))
}

export default function S11MapsPage() {
  const [data, setData] = useState([])
  const history = useHistory()

  function buttonFormatter(cell) {
    return (
      <Tooltip title="Editar">
        <Button
          style={buttonsStyle}
          size="small"
          onClick={() => history.push('/edit-s11-map/' + cell)}
        >
          <EditIcon />
        </Button>
      </Tooltip>
    )
  }

  const columns = [
    { dataField: 'key', text: 'Identificador', sort: true },
    { dataField: 'fullName', text: 'Nombre', sort: true },
    { dataField: 'url', text: 'URL S11', sort: true },
    { dataField: 'id', text: '', formatter: buttonFormatter },
  ]

  useEffect(() => {
    getS11MapsAdmin()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data)
        }
      })
      .catch((error) => {
        alertError({ error, customMessage: 'No se pudieron cargar los mapas S11.' })
      })
  }, [])

  return (
    <Card>
      <CardHeader title="Mapas S11" />
      <CardBody>
        <Table data={getData(data)} columns={columns} />
      </CardBody>
    </Card>
  )
}
